import React from "react";
import {
  CalendarDaysIcon,
  PencilSquareIcon,
  UserPlusIcon,
} from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { ClockIcon } from "@heroicons/react/24/outline";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import { checkPermission } from "../checkPermission";
import { storedToken } from "../auth";

export const dashboardLinks = [
  {
    id: "dashboard_1",
    name: "Student",
    icon: <UserPlusIcon />,
    child: "NewStudent",
    show: storedToken
      ? checkPermission(["school_admin", "conference_admin"])
      : false,
  },
  {
    id: "dashboard_2",
    name: "Instructor",
    icon: <UserPlusIcon />,
    path: "/instructors/new",
    show: storedToken
      ? checkPermission(["school_admin", "conference_admin"])
      : false,
  },
  {
    id: "dashboard_3",
    name: "School",
    icon: <LockClosedIcon />,
    path: "/schools/new",
    show: storedToken ? checkPermission(["global_admin"]) : false,
    globalAdmin: true,
  },
  {
    id: "dashboard_4",
    name: "Seminar",
    icon: <ClockIcon />,
    child: "SchoolSelect",
    show: storedToken
      ? checkPermission(["school_admin", "global_admin"])
      : false,
  },
];

export const studentLinks = [
  {
    id: "students_1",
    name: "Lesson",
    icon: <LockClosedIcon />,
    child: "NewStudentLesson",
  },
  {
    id: "students_2",
    name: "Visit",
    icon: <CalendarDaysIcon />,
    child: "NewStudentVisit",
  },
  {
    id: "students_3",
    name: "Note",
    icon: <PencilSquareIcon />,
    child: "NewStudentNote",
  },
  {
    id: "students_4",
    name: "Decision",
    icon: <CheckCircleIcon />,
    child: "NewStudentDecision",
  },
  {
    id: "students_5",
    name: "Product",
    icon: <LockClosedIcon />,
    child: "NewStudentProduct",
  },
  // {
  //   id: "students_6",
  //   name: "Reminder",
  //   icon: <ClockIcon />,
  //   child: "NewStudentReminder",
  // },
];
